import { PartnerOrder } from './../../admin/pages/order/partner-order';
import { Product } from './../../admin/pages/product/product';
export class CartItem {  
    partnerOrder: PartnerOrder;

    constructor(){
        this.partnerOrder = new PartnerOrder();
    }
}
